/**
 * Parses Graph API user resource to retrieve initials, excluding middle initial.
 *
 * @param {Object} person Graph API user resource of interest.
 * @returns {string} user's initials.
 */
export const getInitialsFromPerson = person => {
	let initials = '';
	if (person.givenName) {
		initials += person.givenName[0].toUpperCase();
	}
	if (person.surname) {
		initials += person.surname[0].toUpperCase();
	}
	if (!initials && person.displayName) {
		const arrName = person.displayName.split(/ /);

		// iterate through parts of display name in reverse order, skipping possible third index containing middle initial
		for (let i = 1; i >= 0 && i < arrName.length; i--) {
			if (arrName[i][0]) {
				initials += arrName[i][0].toUpperCase();
			}
		}
	}
	return initials;
};
